/* las-cart-lock.js
   Keeps the Engraving add-on line in step with the engraved pieces.

   Loaded on every page from sections/cart-drawer.liquid (and still from
   snippets/line-item.liquid), so it is already running when a customer first
   adds an engraved piece and then changes its quantity in the drawer.

   The add-on line has no quantity selector and no Remove link, so the customer
   can only change the PIECE. After every cart change this works out how many
   engraved sides each piece needs (engraved sides x piece quantity) and moves
   the matching $20 add-on line up or down to match:
     - piece quantity 1 -> 2 with one engraved side: add-on 1 -> 2
     - piece quantity 2 -> 1: add-on 2 -> 1
     - piece removed: its add-on line is removed
   Add-on lines are matched to their piece through the add-on's "For"
   property, which starts with the piece title and its options.
*/
(function(){
  if(window.__LAS_CART_LOCK_V2__) return;
  window.__LAS_CART_LOCK_V2__ = true;
  window.__LAS_CART_LOCK__ = true;

  var ADDON_HANDLE = "engraving-add-on";
  var SEP = " · ";
  var busy = false, timer = null, addonVariantId = null;
  /* Cart requests still in flight. The customizers add the piece and then its
     add-on in two requests; we wait until both have landed before checking,
     or we would see the piece without its add-on and add a second one. */
  var pending = 0;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";

  function isAddon(item){
    return (item.handle === ADDON_HANDLE) ||
           (item.product_title || "").trim().toLowerCase() === "engraving";
  }

  function engraved(v){
    return !!(v && String(v).trim() && String(v).trim().toLowerCase() !== "none");
  }

  function sides(item){
    var p = item.properties || {}, n = 0;
    if(engraved(p["Front Engraving"])) n++;
    if(engraved(p["Back Engraving"])) n++;
    return n;
  }

  function optionKey(item){
    var opts = (item.options_with_values || []).map(function(o){ return o.value; });
    if(!opts.length && item.variant_title) opts = String(item.variant_title).split(" / ");
    return [item.product_title].concat(opts).join(SEP);
  }

  function post(url, body){
    return fetch(root + url, {
      method: "POST",
      headers: {"Content-Type": "application/json", "Accept": "application/json"},
      credentials: "same-origin",
      body: JSON.stringify(body)
    });
  }

  function getCart(){
    return fetch(root + "cart.js", {headers: {"Accept": "application/json"}, credentials: "same-origin", cache: "no-store"})
      .then(function(r){ return r.json(); });
  }

  function getAddonVariantId(addons){
    if(addons.length) return Promise.resolve(addons[0].variant_id);
    if(addonVariantId) return Promise.resolve(addonVariantId);
    return fetch(root + "products/" + ADDON_HANDLE + ".js", {credentials: "same-origin"})
      .then(function(r){ return r.json(); })
      .then(function(p){
        addonVariantId = p && p.variants && p.variants[0] && p.variants[0].id;
        return addonVariantId;
      });
  }

  function refreshUI(){
    try{
      document.dispatchEvent(new CustomEvent("cart:refresh", {bubbles: true}));
    }catch(e){}
    if(/^\/cart(\/|$|\?)/.test(window.location.pathname)){
      setTimeout(function(){ window.location.reload(); }, 150);
    }
  }

  function reconcile(){
    if(busy) return;
    if(pending > 0){ schedule(); return; }
    busy = true;
    getCart().then(function(cart){
      var items = (cart && cart.items) || [];
      var pieces = [], addons = [];
      items.forEach(function(it){
        if(isAddon(it)) addons.push(it);
        else if(sides(it) > 0) pieces.push(it);
      });
      if(!pieces.length && !addons.length){ busy = false; return; }

      /* Group the need by piece (title + options). */
      var groups = {}, order = [];
      function group(key){
        if(!groups[key]){ groups[key] = {need: 0, addons: [], piece: null}; order.push(key); }
        return groups[key];
      }
      pieces.forEach(function(it){
        var g = group(optionKey(it));
        g.need += sides(it) * it.quantity;
        if(!g.piece) g.piece = it;
      });

      /* Match each add-on line to a piece group through its "For" text. */
      var orphans = [];
      addons.forEach(function(a){
        var forText = String((a.properties || {})["For"] || "");
        var key = null, i;
        for(i = 0; i < pieces.length && !key; i++){
          var k = optionKey(pieces[i]);
          if(forText === k || forText.indexOf(k + SEP) === 0) key = k;
        }
        for(i = 0; i < pieces.length && !key; i++){
          var t = pieces[i].product_title;
          if(forText === t || forText.indexOf(t + SEP) === 0) key = optionKey(pieces[i]);
        }
        if(key) group(key).addons.push(a);
        else orphans.push(a);
      });

      var changes = [], adds = [];
      order.forEach(function(key){
        var g = groups[key];
        var have = g.addons.reduce(function(n, a){ return n + a.quantity; }, 0);
        var diff = g.need - have;
        if(diff > 0){
          if(g.addons.length){
            var first = g.addons[0];
            changes.push({key: first.key, quantity: first.quantity + diff});
          }else if(g.piece){
            var p = g.piece.properties || {};
            adds.push({quantity: diff, properties: {
              "For": key,
              "Front": engraved(p["Front Engraving"]) ? String(p["Front Engraving"]) : "None",
              "Back": engraved(p["Back Engraving"]) ? String(p["Back Engraving"]) : "None"
            }});
          }
        }else if(diff < 0){
          var over = -diff;
          for(var i = g.addons.length - 1; i >= 0 && over > 0; i--){
            var a = g.addons[i], take = Math.min(over, a.quantity);
            changes.push({key: a.key, quantity: a.quantity - take});
            over -= take;
          }
        }
      });
      /* Add-on lines whose piece has left the cart. */
      orphans.forEach(function(a){ changes.push({key: a.key, quantity: 0}); });

      if(!changes.length && !adds.length){ busy = false; return; }

      var chain = Promise.resolve();
      changes.forEach(function(c){
        chain = chain.then(function(){ return post("cart/change.js", {id: c.key, quantity: c.quantity}); });
      });
      if(adds.length){
        chain = chain.then(function(){ return getAddonVariantId(addons); }).then(function(vid){
          if(!vid) return;
          return post("cart/add.js", {items: adds.map(function(x){
            return {id: vid, quantity: x.quantity, properties: x.properties};
          })});
        });
      }
      chain.then(function(){
        busy = false;
        refreshUI();
      }).catch(function(){ busy = false; });
    }).catch(function(){ busy = false; });
  }

  function schedule(){
    clearTimeout(timer);
    timer = setTimeout(reconcile, 700);
  }

  /* Any cart mutation the theme makes, whatever endpoint it uses. */
  var origFetch = window.fetch;
  window.fetch = function(input, init){
    var url = "";
    try{ url = typeof input === "string" ? input : ((input && input.url) || ""); }catch(e){}
    var isMutation = /\/cart\/(change|update|add|clear)/.test(url);
    if(isMutation){ pending++; clearTimeout(timer); }
    var out = origFetch.apply(window, arguments);
    if(isMutation){
      var settle = function(){
        pending = Math.max(0, pending - 1);
        if(!busy) schedule();
      };
      out.then(settle, settle);
    }
    return out;
  };

  if(window.XMLHttpRequest){
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url){
      try{
        if(typeof url === "string" && /\/cart\/(change|update|add|clear)/.test(url)){
          pending++; clearTimeout(timer);
          this.addEventListener("loadend", function(){
            pending = Math.max(0, pending - 1);
            if(!busy) schedule();
          });
        }
      }catch(e){}
      return origOpen.apply(this, arguments);
    };
  }

  /* On page load, only check when the cart already holds an engraving line. */
  function initialCheck(){
    if(document.querySelector(".line-item--locked")) schedule();
  }
  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", initialCheck);
  }else{
    initialCheck();
  }
})();

/* Studio-only line item properties.
   Shopify checkout, the order status page and order emails list every line
   item property unless its name starts with "_". These ones are for the studio
   (preview renders, uploaded artwork, engraving art files, placement, font
   and device info), so they
   are renamed to "_Name" the moment any script puts them on the add-to-cart
   form data. They still arrive on the order in Shopify admin, as "_Preview
   Front", "_Engraving Font" and so on. What the customer chose (ring size,
   finish, engraving text, gift options) stays visible.
   Works no matter which script appends the field or in what order, because it
   renames at the FormData level; has/get/set/delete are mapped the same way so
   the existing "already added?" checks keep working. */
(function(){
  if(window.__LAS_HIDDEN_PROPS__ || typeof FormData === "undefined") return;
  window.__LAS_HIDDEN_PROPS__ = true;

  var HIDE = [
    "Preview",                       /* LAS keyring studio (assets/las-keyring.js) */
    "Preview Front", "Preview Back",
    "Front Artwork", "Back Artwork",
    "Front Engraving Art", "Back Engraving Art",
    "Front Placement", "Back Placement",
    "Engraving Font"
  ];
  var MAP = {};
  HIDE.forEach(function(k){ MAP["properties[" + k + "]"] = "properties[_" + k + "]"; });
  function rename(name){
    return Object.prototype.hasOwnProperty.call(MAP, name) ? MAP[name] : name;
  }

  var P = FormData.prototype;
  ["append", "set", "has", "get", "getAll", "delete"].forEach(function(m){
    var orig = P[m];
    if(typeof orig !== "function") return;
    P[m] = function(name){
      var args = Array.prototype.slice.call(arguments);
      args[0] = rename(String(name));
      return orig.apply(this, args);
    };
  });
})();